import { Collapse } from "@mui/material";
import { InputCheck } from "controls";
import React, { useEffect } from "react";

const DashboardAccess = ({ values, setValues }) => {
  useEffect(() => {
    if (!values.id) {
      values.dashboardAccess
        ? setValues((j) => ({
            ...j,
            dashboard: {
              accountsWidgets: true,
              inventoryValue: true,
              topSellingProduct: true,
              topCustomer: true,
              allOutlets: true,
              storeMetrics: true,
            },
          }))
        : setValues((j) => ({
            ...j,
            dashboard: {
              accountsWidgets: false,
              inventoryValue: false,
              topSellingProduct: false,
              topCustomer: false,
              allOutlets: false,
              storeMetrics: false,
            },
          }));
    }
    return () => {};
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [values.dashboardAccess]);

  const handleInpChg = (e) => {
    const { name, checked } = e.target;
    setValues((j) => ({
      ...j,
      dashboard: { ...j.dashboard, [name]: checked },
    }));
  };

  return (
    <Collapse in={values.dashboardAccess || false}>
      <div className="ml-[3px] grid gap-1 mt-[2px] mb-[10px] !uppercase tracking-wider !pl-[10px] border-l-4  border-rounded">
        <InputCheck
          label="Accounts Widgets"
          checked={values.dashboard?.accountsWidgets || false}
          name={"accountsWidgets"}
          onClick={handleInpChg}
        />

        <InputCheck
          label="Inventory Value"
          checked={values.dashboard?.inventoryValue || false}
          name={"inventoryValue"}
          onClick={handleInpChg}
        />

        <InputCheck
          label="Top Selling Product"
          checked={values.dashboard?.topSellingProduct || false}
          name={"topSellingProduct"}
          onClick={handleInpChg}
        />

        <InputCheck
          label="Top Customer"
          checked={values.dashboard?.topCustomer || false}
          name={"topCustomer"}
          onClick={handleInpChg}
        />

        <InputCheck
          label="All Outlets"
          checked={values.dashboard?.allOutlets || false}
          name={"allOutlets"}
          onClick={handleInpChg}
        />

        <InputCheck
          label="Store Metrics"
          checked={values.dashboard?.storeMetrics || false}
          name={"storeMetrics"}
          onClick={handleInpChg}
        />
      </div>
    </Collapse>
  );
};

export default DashboardAccess;
